<script>
import { mapGetters, mapMutations } from "vuex";
import PrevNextNavButtons from "@/components/PrevNextNavButtons"
import InvoiceService from "@/store/services/invoice.service.js"

export default {
  name: 'PrevNextNavInvoices',
  extends: PrevNextNavButtons,
  props: {
    isQuotation: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters({ 
      tempItemList: 'invoices/getTempInvoiceList',
      initialNext: 'invoices/getTempInvoiceListNext',
      isControlPanel: "main/isControlPanel"
    }),
  },
  created () {
    this.checkPrevNext()
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'invoices/SET_TEMP_INVOICE_LIST') {
        this.checkPrevNext()
      }
    })
  },
  destroyed () {
    this.unsubscribe()
  },
  methods: {
    ...mapMutations({ 
      setTempItemList: "invoices/SET_TEMP_INVOICE_LIST",
    }),
    async getMoreItems (recurring = false) {
      // need next tick to wait for initialNext mutation
      this.$nextTick(() => {
        if ((this.initialNext && !this.useCurrentNext) || (this.currentNext && this.useCurrentNext)) {
          if(!this.currentNext) this.currentNext = this.initialNext
          return InvoiceService.loadNextPage(this.currentNext).then((response) => {
            if (response.data.results) {
              this.useCurrentNext = true
              this.currentNext = response.data.next
              this.setTempItemList(this.tempItemList.concat(response.data.results))
              if (recurring) this.checkPrevNext()
            }
          })
        }
      })
    },
    navigateTo (target_id, direction) {
      if (target_id) {
        this.navigating = direction
        this.$emit('nav-direction', this.navigating)
        if (this.isQuotation) {
          this.$router.push({ name: 'ControlPanelQuotationView', params: { quotationId: target_id } }).catch(() => {})
        } else {
          this.$router.push({ name: !this.isControlPanel ? 'InvoiceView' : 'ControlPanelInvoiceView', params: { invoiceId: target_id } }).catch(() => {})
        }
      }
    }
  }
}
</script>
